import { render, staticRenderFns } from "./StackedBarChartWidget.vue?vue&type=template&id=16fb8848&scoped=true"
import script from "./StackedBarChartWidget.vue?vue&type=script&lang=js"
export * from "./StackedBarChartWidget.vue?vue&type=script&lang=js"
import style0 from "./StackedBarChartWidget.vue?vue&type=style&index=0&id=16fb8848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fb8848",
  null
  
)

export default component.exports